<template>
	<div class="rebate_box">
		<div class="registerModal" v-show="isShowCon">
			<div class="pageModal">
				<div class="registerOk">
					<p>您已获得一次免费租号机会</p>
					<p>现金好礼到账后将发放至你的虚贝账户</p>
					<div class="lease_button" @click="leaseButtonClick"></div>
				</div>
				<div class="register_closed" @click="registerClosed"></div>
			</div>
		</div>
		<span class="rebate_box_span">您的好友{{ phone }}邀请您加入虚贝网</span>
		<div class="rebate_form">
			<div class="rebate_form_phone">
				<span>手机号：</span>
				<input
					class="rebate_input"
					placeholder="请输入您的手机号码！"
					v-model="moblie"
					oninput="if(value.length>11)value=value.slice(0,11)"
				/>
			</div>
			<div class="rebate_form_phone">
				<span>短信验证码：</span>
				<input
					class="rebate_input_code"
					placeholder="请输入短信验证码！"
					v-model="phoneCode"
					oninput="if(value.length>6)value=value.slice(0,6)"
				/>
				<button class="rebate_button" @click="onClick" v-show="!isSend">获取验证码</button>
				<button class="rebate_button" v-show="isSend">{{ codeTime }}s</button>
			</div>
			<div class="rebate_form_phone">
				<span>密码：</span>
				<input class="rebate_input passport_style" placeholder="请输入登录密码！" type="password" v-model="password" />
			</div>
			<div>
				<span class="rebate_pass_word">密码为6-20个英文字母，数字或符号</span>
			</div>
		</div>
		<div class="rebate_compeleted_button" @click="register"></div>
		<div class="rebate_compeleted_server_loyer">
			<span>完成注册即代表已阅读并同意《服务条款和隐私政策》</span>
		</div>
	</div>
</template>
<script>
import { Toast } from 'mint-ui';
import { PROXY_URL } from '../../../config/env';
let telReg = /^1\d{10}$/;

export default {
	name: 'rebate',
	components: { Toast },
	data: function () {
		return {
			isShowCon: false,
			moblie: '',
			phoneCode: '',
			password: '',
			isSend: false,
			codeTime: 60,
			phone: this.$route.query.phone.substr(0, 3) + '****' + this.$route.query.phone.substr(7)
		};
	},
	mounted() {},
	methods: {
		onClick: function () {
			let sele = this;
			if (this.moblie == '') {
				Toast('手机号不能为空！');
				return false;
			}
			if (!telReg.test(this.mobliye)) {
				Toast('请输入正确的手机号！');
			} else {
				this.getZuli();
			}
		},
		getZuli: function () {
			var self = this;
			this.ajax.get(PROXY_URL.user + '/reg/captcha/getUrl').then(res => {
				if (res.data.code == '1') {
					var HEAD = document.getElementsByTagName('head').item(0) || document.documentElement;
					var script = document.createElement('script');
					script.setAttribute('type', 'text/javascript');
					script.setAttribute('src', res.data.result);
					HEAD.appendChild(script);

					script.onload = function () {
						var capOption = { callback: cbfn, type: 'popup' };
						capInit(document.getElementById('TCaptcha'), capOption);
						//回调函数：验证码页面关闭时回调
						self.isMask = true;
						function cbfn(retJson) {
							if (retJson.ret == 0) {
								// 用户验证成功
								console.log(retJson);
								self.isMask = false;

								let data = {
									ticket: retJson.ticket
								};

								self.ajax
									.get(
										PROXY_URL.service +
											'/anon/diversion/sendCode?mobile=' +
											self.moblie +
											'&businessNo=xubei&ticket=' +
											data.ticket
									)
									.then(res => {
										console.log(res);
										if (res.data.code == '1') {
											Toast('验证码发送成功！');
										} else {
											Toast(res.data.message);
										}
									})
									.catch(error => {});

								capDestroy();
							} else {
								//用户关闭验证码页面，没有验证
								self.isMask = false;
								capDestroy();
							}
						}
					};
				} else {
					self.$toast(res.data.message);
				}
			});
		},
		countTime() {
			let time = 60;
			let self = this;
			let codeT = window.setInterval(function () {
				time--;
				self.codeTime = time;
				if (time == 0) {
					self.isSend = false;
					self.codeTime = 60;
					window.clearInterval(codeT);
				}
			}, 1000);
		},
		registerClosed() {
			this.isShowCon = false;
		},
		leaseButtonClick() {
			window.location.href = PROXY_URL.home;
		},
		login() {
			let self = this;
			this.ajax
				.get(PROXY_URL.user + '/login/toLogin?userName=' + self.moblie + '&pwd=' + self.password)
				.then(res => {
					if (res.data.code === '1') {
						this.isShowCon = true;
					} else {
						Toast(res.data.message);
					}
				})
				.catch(error => {
					console.log(error);
				});
		},
		register() {
			console.log(this.$route.query.shareNo);
			let shareNum = this.$route.query.shareNo;
			let self = this;
			if (this.moblie == '') {
				Toast('手机号不能为空！');
				return false;
			}
			if (!telReg.test(this.moblie)) {
				Toast('请输入正确的手机号！');
				return fasle;
			}
			if (this.phoneCode == '') {
				Toast('验证码不能为空！');
				return false;
			}
			if (this.password == '') {
				Toast('密码不能为空！');
				return false;
			}
			if (this.password.length < 6) {
				Toast('密码需为6-20个英文字母，数字或符号组成！');
				return false;
			}
			this.ajax
				.get(
					PROXY_URL.user +
						'/reg/registerUser?mobile=' +
						self.moblie +
						'&loginPwd=' +
						self.password +
						'&code=' +
						self.phoneCode +
						'&shareNo=' +
						shareNum
				)
				.then(res => {
					if (res.data.code === '1') {
						this.login();
					} else {
						Toast(res.data.message);
					}
				})
				.catch(error => {
					console.log(error);
				});
		}
	}
};
</script>
<style lang="scss" scoped>
@function px2rem($px) {
	@return $px / 75;
}
input::-webkit-input-placeholder {
	/* placeholder颜色  */
	color: #5f0306;
	opacity: 0.5;
}
.registerModal {
	position: fixed;
	width: 100%;
	height: px2rem(1334rem);
	background: rgba(0, 0, 0, 0.3);
	z-index: 10;
	.pageModal {
		position: fixed;
		top: 50%;
		left: 50%;
		z-index: 11;
		text-align: center;
		transform: translate(-50%, -50%);
		-webkit-transform: translate(-50%, -50%);
		.registerOk {
			width: px2rem(620rem);
			height: px2rem(460rem);
			background: url(/src/images/rebate/register_ok.png) no-repeat;
			background-size: 100% 100%;
			padding-top: px2rem(257rem);
			p {
				font-size: px2rem(26rem);
				line-height: px2rem(36rem);
				color: #e8a05f;
			}
			.lease_button {
				margin-top: px2rem(40rem);
				display: inline-block;
				background: url(/static/images/rebate/lease_button.png) no-repeat;
				background-size: 100% 100%;
				width: px2rem(485rem);
				height: px2rem(77rem);
			}
		}
		.register_closed {
			background: url(/static/images/rebate/register_closed.png) no-repeat;
			background-size: 100% 100%;
			height: px2rem(52rem);
			width: px2rem(52rem);
			position: fixed;
			left: 50%;
			bottom: px2rem(-70rem);
			margin-left: px2rem(-26rem);
		}
	}
}
.rebate_box {
	background: url(/src/images/rebate/rebatebg.png) no-repeat;
	background-size: 100% px2rem(1334rem);
	width: 100%;
	height: px2rem(1334rem);
	position: relative;
	.rebate_compeleted_server_loyer {
		width: 100%;
		text-align: center;
		position: absolute;
		left: 0;
		bottom: px2rem(16rem);
		span {
			font-size: px2rem(22rem);
			color: #fcc99a;
			opacity: 0.3;
		}
	}
	.rebate_compeleted_button {
		width: px2rem(675rem);
		height: px2rem(90rem);
		background: url(/src/images/rebate/rebate_button.png) no-repeat;
		background-size: 100% 100%;
		position: absolute;
		left: 50%;
		margin-left: px2rem(-338rem);
		bottom: px2rem(74rem);
	}
	.rebate_box_span {
		position: absolute;
		left: 0;
		display: inline-block;
		width: 100%;
		text-align: center;
		top: px2rem(661rem);
		font-size: px2rem(24rem);
		color: #3f0a0c;
	}
	.rebate_form {
		width: 100%;
		position: absolute;
		left: 0;
		top: px2rem(743rem);
		padding-left: px2rem(65rem);
		.rebate_pass_word {
			font-size: px2rem(22rem);
			color: #5f0306;
			opacity: 0.8;
			padding-left: px2rem(30rem);
		}
		.rebate_warn_word {
			font-size: px2rem(22rem);
			color: red;
			opacity: 0.8;
			padding-left: px2rem(30rem);
		}
		.rebate_input {
			width: px2rem(620rem);
			height: px2rem(80rem);
			background: none;
			border: solid px2rem(1rem) #590306;
			padding: px2rem(30rem);
			padding-left: px2rem(127rem);
		}
		.rebate_input_code {
			width: px2rem(440rem);
			height: px2rem(80rem);
			background: none;
			border: solid px2rem(1rem) #590306;
			padding: px2rem(30rem);
			padding-left: px2rem(173rem);
		}
		.rebate_form_phone {
			margin-bottom: px2rem(30rem);
			position: relative;
			span {
				position: absolute;
				left: px2rem(30rem);
				top: px2rem(24rem);
				font-size: px2rem(24rem);
				color: #5f0306;
			}
			.rebate_button {
				width: px2rem(175rem);
				height: px2rem(80rem);
				background-color: #fcbe80;
				border: solid 1px #590306;
			}
			.passport_style {
				padding-left: px2rem(103rem) !important;
			}
		}
	}
}
</style>



// WEBPACK FOOTER //
// src/pages/activity/rebate/rebate.vue